
import Menu from './Compartido/Menu.jsx';
import BuscadorExperiencia from './Experiencia/BuscadorExperiencia.jsx';
import PropiedadesExperiencia from './Experiencia/PropiedadesExperiencia.jsx';
import DatosExperiencia from './Experiencia/DatosExperiencia.jsx';
import Footer from './Compartido/Footer.jsx';

const Destino = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <BuscadorExperiencia
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
                lang={props.lang}
                experiencia={props.laexperiencia}
                config={props.websgrupo}
            />
            <PropiedadesExperiencia
                lang={props.lang}
                ruta={props.ruta}
                propiedadesexperiencias={props.propiedadesexperiencias}
                config={props.websgrupo}
            />
            <DatosExperiencia
                experiencia={props.laexperiencia}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Destino;
